import { ServicePartnerModel, ServicePartnerModelObject } from './servicePartnersModel';

export interface BankAccountsModel {
  id: number;
  accountName: string;
  accountNumber: string;
  bankName: string;
  ifscCode: string;
  micrCode: string;
  servicePartner: ServicePartnerModel;
  accountTypeId: number;
  isActive: boolean;
}

export interface BankAccountTypesModel {
    id: number;
    name: string;
}

export const BankAccountsModelData = {
    id: 0,
    accountName: '',
    accountNumber: '',
    bankName: '',
    ifscCode: '',
    micrCode: '',
    servicePartner: ServicePartnerModelObject,
    accountTypeId: 0,
    isActive: true,
  }